/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalemoodshiftsstrong4Inputs */



/**
* | output |
* | --- |
* | "You notice how your own mood and the mood of people around you changes, and you can react to those changes in time." |
*
* @param {Eisubscalemoodshiftsstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalemoodshiftsstrong4 = /** @type {((inputs?: Eisubscalemoodshiftsstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalemoodshiftsstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You notice how your own mood and the mood of people around you changes, and you can react to those changes in time.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas cómo cambia tu ánimo y el de quienes te rodean, y puedes reaccionar a tiempo a esos cambios.")
	return /** @type {LocalizedString} */ ("Ты замечаешь, как меняется настроение твоё и окружающих, и можешь вовремя отреагировать на эти изменения.")
});
export { eisubscalemoodshiftsstrong4 as "eiSubscaleMoodShiftsStrong" }